
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from './Components/Header';
import { Home } from './Pages/Home';
import { Bindtrack } from './Pages/Solutions/Bindtrack';
import { Cases } from './Pages/Cases';
import { AppDashboard } from './Pages/Cases/AppDashboard';
import { WhoWeAre } from './Pages/WhoWeAre';
import { Contact } from './Pages/Contact';
import { FooterSection } from "./Components/FooterSection";
import { ContactSection } from './Components/ContactSection';
import { Jobs } from "./Pages/Jobs";
import { Bindinntech } from "./Pages/Solutions/Bindinntech";
import { Fisioteraplay } from "./Pages/Solutions/Fisioteraplay";
import { Whatsign } from "./Pages/Solutions/Whatsign";
import { Atendevet } from "./Pages/Solutions/Atendevet";
import { Icc } from "./Pages/Cases/Icc";
import { SurfCenter } from "./Pages/Cases/SurfCenter";
import { Ecosalva } from "./Pages/Cases/Ecosalva";
import { Agroflow } from "./Pages/Cases/Agroflow";
import { Whistleblowing } from "./Pages/Whistleblowing";


function App() {
  return (
    <BrowserRouter >
      <div className="App">
        <Header />
        <Routes>
          <Route
            path="/"
            element={<Home />}
          />
          <Route
            path="/solucoes/bindinntech"
            element={<Bindinntech />}
          />
          <Route
            path="/solucoes/bindtrack"
            element={<Bindtrack />}
          />
          <Route
            path="/solucoes/fisioteraplay"
            element={<Fisioteraplay />}
          />
          <Route
            path="/solucoes/atendevet"
            element={<Atendevet />}
          />
          <Route
            path="/solucoes/whatsign"
            element={<Whatsign />}
          />

          <Route
            path="/cases"
            element={<Cases />}
          />
          <Route
            path="/cases/icc"
            element={<Icc />}
          />
          <Route
            path="/cases/surf-center"
            element={<SurfCenter />}
          />
          <Route
            path="/cases/ecosalva"
            element={<Ecosalva />}
          />
          <Route
            path="/cases/agroflow"
            element={<Agroflow />}
          />

          <Route
            path="/quem-somos"
            element={<WhoWeAre />}
          />
          <Route
            path="/contato"
            element={<Contact />}
          />
          <Route
            path="/canalDenuncia"
            element={<Whistleblowing />}
          />
          <Route
            path="/jobs"
            element={<Jobs />}
          />
        </Routes>

        <ContactSection />
        <FooterSection />
      </div>
    </BrowserRouter>
  );
}

export default App;
